import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';
import './index.css';

const rootElementContainer = ReactDOM.createRoot(
  document.getElementById('root')
);
rootElementContainer.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// 📡 LIVE PRODUCTION PROGRESSIVE WEB APP HANDSHAKE REGISTRY TRIGGER
// Instantly maps out the service worker cache lanes as soon as browser boots up online
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registrationDetails) => {
        console.log(
          '🏁 PWA PROTOCOL ACTIVE: ServiceWorker successfully mapped to scopes: ',
          registrationDetails.scope
        );

        // Update detection: listen for a new service worker being found
        registrationDetails.addEventListener('updatefound', () => {
          const newWorker = registrationDetails.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // A new worker is installed and waiting, and an old SW is controlling
              // This is an UPDATE, not a first install
              window.dispatchEvent(
                new CustomEvent('sw-update-available', { detail: registrationDetails })
              );
            }
          });
        });

        // Handle case where a worker is already waiting at registration time
        if (registrationDetails.waiting) {
          window.dispatchEvent(
            new CustomEvent('sw-update-available', { detail: registrationDetails })
          );
        }
      })
      .catch((registrationError) => {
        console.error(
          '❌ PWA PROTOCOL REJECTED: Registration execution error -> ',
          registrationError
        );
      });
  });

  // Handle controller change (new SW takes control) - reload page once
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
